// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/report_dashboards" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportDashboards } from "./constants";
import type { EngagementReportDashboardsParams, EngagementReportDashboardsResult } from "./types";

export const getDataTableEngagementReportDashboards = reactQueryTableFetcherAdapter(
  engagementReportDashboards,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 20, start = 0, sortdir, sortby }: EngagementReportDashboardsParams
  ): Promise<EngagementReportDashboardsResult> => {
    return fetch(
      "/engagement/report_dashboards",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
